module.exports = __webpack_public_path__ + "img/poster_black_text.d33833da.png";